import React, { memo } from 'react';

// Reusable Skeleton Components
const SkeletonText = ({ width = '100%', className = '' }) => (
  <h3 className={`baseSkeleton nudges-skeleton-text mb-3 ${className}`} style={{ width }} />
);

const SkeletonTable = ({ rows = 7, cols = 1 }) => (
  <table className="table generic-table-skeleton-table">
    <thead>
      <tr>
        {[...Array(cols)].map((_, colIndex) => (
          <th key={colIndex} className="baseSkeleton nudges-skeleton-text" />
        ))}
      </tr>
    </thead>
    <tbody>
      {[...Array(rows)].map((_, rowIndex) => (
        <tr key={rowIndex}>
          {[...Array(cols)].map((_, colIndex) => (
            <td key={colIndex}>
              <div className="baseSkeleton nudges-skeleton-text" />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

const SkeletonCards = ({ numberOfCards = 4 }) => (
  <div className="nudges-skeleton-row">
    {[...Array(2)].map((_, index) => (
      <span key={index}>
        {[...Array(numberOfCards)].map((_, idx) => (
          <div key={idx} className="baseSkeleton nudges-skeleton-med-card" />
        ))}
      </span>
    ))}
  </div>
);

function ContactCompSkeleton({ numberOfCards = 4 }) {
  return (
    <>
      <SkeletonText width="100%" />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'row' }}>
        <div className="container my-1" style={{ width: '20vw' }}>
          <SkeletonText width="60%" />
          <SkeletonTable rows={7} cols={1} />
        </div>
        <SkeletonCards numberOfCards={numberOfCards} />
      </div>
      <SkeletonText width="100%" />
    </>
  );
}

export default memo(ContactCompSkeleton);